import React, { useEffect, useState } from "react";
import { useStore } from "@nanostores/react";

import { __t } from "../../utils/translate";
import { Product } from "../../utils/types";
import { $isBundleOutOfStock } from "../../utils/store";

import AttributeSelector from "./attributeSelector";
import { useProductContext } from "@/providers/productProvider";

type VariationProps = {
    className?: string;
    product: Product;
    isCoupon: boolean;
    setVariation: (id: any, attributes: any) => void;
    setAttributeBundle?: (attribute: any) => void;
    defaultAttributes: Record<string, unknown>;
    isBundle?: boolean;
    itemId?: string;
};

const Variation: React.FC<VariationProps> = ({
    className = "",
    product,
    isCoupon,
    setVariation,
    defaultAttributes,
    isBundle,
    itemId,
    setAttributeBundle
}) => {
    const { setIsOutOfStock } = useProductContext();
    const isBundleOutOfStock = useStore($isBundleOutOfStock);

    const selectVariation = (attributes: { [x: string]: any; }) => {
        const t_var = product.variations_product.find((variation) => {
            const attributes_find = variation.attributes2.filter(attr => {
                return attributes[isBundle ? `bundle_attribute_` + attr.attribute + '_' + itemId : attr.attribute] == attr.value;
            })

            return attributes_find.length === variation.attributes2.length;
        });

        if (t_var && t_var.id) {
            setVariationId(t_var.id);
            setVariation(t_var.id, attributes);

            if (isBundle && itemId) {
                let newBundleOutOfStock = {
                    ...isBundleOutOfStock,
                    [parseInt(itemId)]: t_var.stock_status !== "instock"
                }
                $isBundleOutOfStock.set(newBundleOutOfStock);

                if (Object.values(newBundleOutOfStock).some(status => status === true)) {
                    setIsOutOfStock(true);
                } else {
                    setIsOutOfStock(false);
                }
            } else {
                setIsOutOfStock(t_var.stock_status !== "instock");
            }
        }
    }
    const defaultVariationId = product.defaultVariationID;
    const [variationId, setVariationId] = useState(defaultVariationId);

    const [attributes, setAttributes] = useState(defaultAttributes);
    const setAttribute = (attribute: React.SetStateAction<unknown[]>) => {
        if (isBundle) {
            setAttributeBundle(attribute);
            let itemAttributes = {};
            Object.keys(attributes).forEach(key => {
                if (key.endsWith(`_${itemId}`)) {
                    itemAttributes[key] = attributes[key];
                }
            });
            selectVariation({ ...itemAttributes, ...attribute });
        } else {
            selectVariation({ ...attributes, ...attribute });
        }
    };

    useEffect(() => {
        setAttributes(defaultAttributes);
        // selectVariation(defaultAttributes);
    }, [defaultAttributes]);

    return (
        <>
            {product.variation_attributes.map((attribute) =>
                <AttributeSelector
                    isBundle={isBundle}
                    key={attribute.slug}
                    className=""
                    attribute={attribute}
                    setAttribute={setAttribute}
                    selectedAttribute={attributes[isBundle ? `bundle_attribute_` + attribute.slug + '_' + itemId : attribute.slug]}
                    isCoupon={isCoupon}
                    itemId={itemId}
                />
            )}
            {(isBundle && isBundleOutOfStock[itemId]) && (
                <p className={`text-base-16-strong pb-2 md:pb-4 text-red`}>
                    {__t('Out of stock')}
                </p>
            )}
        </>
    );
};

export default Variation;